
<nav class="navbar navbar-expand-md navbar-light">
    <div class="menu-group collapse navbar-collapse" id="navbarSupportedContent">
		<div class="title_costplanning">EBOI</div>

		<mat-nav-list class="inline">
			<a mat-list-item [routerLink]="['/home']" routerLinkActive="active" #home="routerLinkActive" class="menu">Expedite Entry</a>
			<a mat-list-item [routerLink]="['/investigation']" routerLinkActive="active" #investigation="routerLinkActive" class="menu">Investigation</a>
			<a mat-list-item [routerLink]="['/plant']" routerLinkActive="active" #plant="routerLinkActive" class="menu">Plan Versus Actual</a>
			<a mat-list-item [routerLink]="['/reasonId']" routerLinkActive="active" #reasonId="routerLinkActive" class="menu">Master Settings</a>
			<a mat-list-item [routerLink]="['/history']" routerLinkActive="active" #history="routerLinkActive" class="menu">History</a>
		</mat-nav-list>

	</div>
</nav>
